<template>
  <div class="page-container">
    <div class="page-header">
      <CustomHeader title="" />
    </div>
    <div class="page-content result-content">
      <div
        v-if="isSuccess"
        class="content-container"
      >
        <img
          style="width: 0.56rem; height: 0.56rem;"
          src="https://m.hellobike.com/cf5e572a_icon_chenggong%402x.png"
          alt=""
        >
        <label class="lab-buy">购买成功</label>
        <label class="lab-desc">稍后将充入你的哈啰账户</label>
        <div class="btn-container">
          <NormalBtn
            class="normal-btn"
            :lab-style="whiteFont"
            style="margin-left: 0.13rem;"
            :lab-btn="comfirmBtnText"
            @e-click="onClickUseFn"
          />
        </div>
      </div>
      <div
        v-else
        class="content-container"
      >
        <img
          style="width: 0.56rem; height: 0.56rem;"
          src="https://m.hellobike.com/3bae48bf_icon_shibai%402x.png"
          alt=""
        >
        <label class="lab-buy">支付失败</label>
        <label class="lab-desc">订单还未支付成功，请重新支付</label>
        <div class="btn-container">
          <NormalBtn
            class="normal-btn"
            :lab-style="blackFont"
            btn-type="whiteBg"
            lab-btn="查看购买详情"
            @e-click="onClickBuyDetail"
          />
          <!-- 20260108交银小程序环境：支付失败暂时不支持重新支付选择 -->
          <!-- <NormalBtn
            class="normal-btn"
            :lab-style="whiteFont"
            style="margin-left:0.13rem;"
            lab-btn="重新支付"
            @e-click="onClickRePay"
          /> -->
        </div>
      </div>
      <div>
        <!-- <GoodsList /> -->
      </div>
    </div>
  </div>
</template>

<script>
import { env, Native } from '@hb/mbridge';
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import { showThirdPageOld, ticketResultPagejumpLink } from '~mall/common/utils/jumpUrl';
import { setParamsToUrl } from '~mall/common/utils/params';
import { appQueryConfig } from '~mall/common/utils/url';
import { uiMgr } from '~mall/common/uiMgr';
import { actionRePay } from '~mall/model/apis/order';
import { requestGetJumpLink } from '~mall/model/apis/orderApis';
import store from '~mall/model/store';
import { easyBikeAppDownLoadUrl } from '../order/consts';
import { isEasyBikeApp } from '~mall/common/env/env';
import Header from '~mall/components/Header.vue';
import NormalBtn from '~mall/components/NormalBtn.vue'; // 假设 NormalBtn 组件位于此处
import { tryShowWidgetGuide } from '~mall/common/utils/widgetGuide';
import logger from '~mall/common/utils/logger';

export default {
  name: 'TicketPaySuccess',
  components: {
    CustomHeader: Header,
    NormalBtn,
  },
  data() {
    return {
      whiteFont: {
        fontSize: '0.14rem',
        fontWeight: 500,
        color: '#FFFFFF',
      },
      blackFont: {
        fontSize: '0.14rem',
        fontWeight: 400,
        color: '#666666',
      },
      jumpInfo: {
        buttonShowAfterPay: '',
        appJumpUrlAfterPay: '',
        aliPayJumpUrlAfterPay: '',
      },
    };
  },
  computed: {
    storePayInfo() {
      return store.state.ticket.payInfo;
    },
    payInfo() {
      if (this.storePayInfo?.payOrderInfo) {
        return this.storePayInfo;
      }

      const payInfoStr = sessionStorage.getItem('pay_info');

      if (payInfoStr) {
        return JSON.parse(payInfoStr) || null;
      }

      return null;
    },
    payOrders() {
      const orders = this.payInfo?.payOrderInfo;

      if (!orders) {
        return [];
      }

      return Array.isArray(orders) ? orders : [orders];
    },
    multiOrders() {
      return this.payOrders.length > 1;
    },
    comfirmBtnText() {
      if (this.multiOrders) {
        return '立即去使用';
      }

      const { appId } = appQueryConfig;

      if (appId) {
        const appJumpInfo = this.jumpInfo[appId];

        if (appJumpInfo?.buttonShowAfterPay) {
          return appJumpInfo.buttonShowAfterPay;
        }
      }

      if (env.isAliMP || env.isAliMPMonitor || isEasyBikeApp || env.isWechatMini) {
        return this.jumpInfo?.buttonShowAfterPay || '立即去使用';
      }

      return '立即去使用';
    },
    sharedUbtBizInfo() {
      const {
        skuData,
        svipAmount,
        highRecm,
        combiProduct,
      } = this.payInfo || {};
      const bizInfo = {
        adsource: appQueryConfig.adsource,
        tabName: window.sessionStorage.getItem('tabName'),
        tyingProductChoose: false,
        mainProductId: skuData?.spuId,
        ischooserewards: svipAmount ? 1 : 2,
        highRecm,
        sku_name: skuData?.goodsName,
        skuid: skuData?.skuid,
        marketingLabel: this.marketingLabel,
      };

      if (!combiProduct) {
        return bizInfo;
      }

      const {
        spuId,
        goodsName,
        salePrice,
        categoryId,
      } = combiProduct;

      return {
        ...bizInfo,
        tyingProductId: spuId,
        tyingProductName: goodsName,
        tyingProductPrice: salePrice,
        tyingProductBusiness: categoryId,
        tyingProductChoose: true,
      };
    },
    marketingLabel() {
      const skudata = store.getters['skuData/getSkuData'];

      const {
        specialPaymentId,
        promotionPaymentContent,
      } = skudata || {};

      return JSON.stringify({
        specialPaymentId,
        promotionPaymentContent,
      });
    },
    querySuccess() {
      return this.$route.query.isSuccess === '1';
    },
    isSuccess() {
      if (this.payInfo) {
        return this.payInfo.result === '1';
      }

      return this.querySuccess;
    },
  },
  async mounted() {
    if (!isEasyBikeApp) {
      Native.setPageTitle({
        title: '',
      });
    } else {
      Native.callNative({
        classMap: 'NavBar',
        method: 'setStatusBar',
        params: { isShowStatusBar: true },
      });
      Native.callNative({
        classMap: 'NavBar',
        method: 'setStatusBarColor',
        params: { isShowStatusBar: true, isDarkFont: false, colorCode: '#ffffff' },
      });
    }

    UBT.pageView({
      pageId: 'platform_buysuccess',
      categoryId: 'platform',
      businessInfo: this.sharedUbtBizInfo,
    });

    if (this.multiOrders) {
      return;
    }

    if (this.isSuccess) {
      // 立即去使用曝光埋点
      UBT.moduleExpose({
        pageId: 'platform_buysuccess',
        categoryId: 'platform',
        moduleId: 'platform_buysucess_gotoUse',
        contentId: 'platform_buysucess_gotoUse',
        exposureTimes: 1,
        businessInfo: this.sharedUbtBizInfo,
      });
    }

    const categoryId = this.payInfo?.skuData?.categoryId || this.$route.query.categoryId || '';

    if (categoryId) {
      const res = await requestGetJumpLink({ categoryId });
      if (res) {
        this.jumpInfo = res;
      }
    }

    // 小组件引导：进入支付结果页时触发（不区分成功/失败）
    logger('[小组件引导] 支付结果页触发引导');
    tryShowWidgetGuide({ pageType: 'payResult', source: 'pay_result', categoryId });
  },
  beforeDestroy() {
    UBT.pageViewOut({
      pageId: 'platform_buysuccess',
      categoryId: 'platform',
      businessInfo: this.sharedUbtBizInfo,
    });
  },
  methods: {
    // 查看购买详情
    onClickBuyDetail() {
      UBT.clickButton({
        pageId: 'couponmall_buysuccess',
        buttonName: 'couponmall_buysucess_record',
        categoryId: 'hellomall',
        businessInfo: {},
      });
      if (!this.payInfo) {
        uiMgr.pushPage({
          name: 'OrderList',
        });
        return;
      }
      if (this.payInfo.activityUrl) {
        showThirdPageOld(setParamsToUrl({
          adsource: 'supermall',
          remark: '卡券',
        }, this.payInfo.activityUrl));
      } else {
        if (this.multiOrders) {
          uiMgr.redirectPage('/order');
          return;
        }

        const payOrderInfo = this.payOrders[0];
        const billNo = payOrderInfo?.billNo || this.$route.query.billNo;
        const url = `/order/${billNo}`;
        uiMgr.redirectPage(url);
      }
    },

    // 去用车
    async onClickUseFn() {
      UBT.clickButton({
        pageId: 'platform_buysuccess',
        buttonName: 'platform_buysucess_gotoUse',
        categoryId: 'platform',
        businessInfo: this.sharedUbtBizInfo,
      });

      if (this.$route.query.adsource === 'alipay_shouyemiaosha') {
        showThirdPageOld(easyBikeAppDownLoadUrl);
        return;
      }

      if (this.multiOrders) {
        uiMgr.redirectPage('/order');
        return;
      }

      if (!this.jumpInfo) {
        uiMgr.replacePage('/bounty');
        return;
      }
      ticketResultPagejumpLink(this.jumpInfo);
    },

    // 重新支付
    onClickRePay() {
      actionRePay({});
      UBT.clickButton({
        pageId: 'couponmall_buysuccess',
        buttonName: 'couponmall_buysucess_finish',
        categoryId: 'hellomall',
        businessInfo: {},
      });
    },
  },
};
</script>

<style lang="less" scoped>
  .result-content {
    overflow: scroll;
  }

  .content-container {
    width: 100%;
    // height: 100%;
    height: 2.45rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 0.43rem;
    // justify-content: center;
  }

  .lab-buy {
    color: #333;
    font-size: 0.18rem;
    font-weight: 500;
    margin-top: 0.15rem;
  }

  .lab-desc {
    color: #999;
    font-size: 0.14rem;
    font-weight: 400;
    margin-top: 0.02rem;
  }

  .btn-container {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 0.8rem;
  }

  .normal-btn {
    width: 1.22rem;
    height: 0.4rem;
  }
</style>
